import Head from 'next/head';
import { useRouter } from 'next/router';
import { v4 as uuidv4 } from 'uuid';

import { CmsContent } from '@tgg/ui';

import { getOrganisationSchemaForPage } from './StandardPage.helpers';
import { StandardPageProperties } from './StandardPage.types';

export function StandardPage({
    titleBox,
    content,
    cmsPage,
    gyms,
    promoSnackBarOptions,
    organisationSchema,
}: StandardPageProperties) {
    const router = useRouter();
    const isHomePage = router.pathname === '/';
    const organisationSchemaObject = organisationSchema
        ? getOrganisationSchemaForPage(
              organisationSchema.organisationName,
              organisationSchema.url,
              organisationSchema.links,
          )
        : null;

    const contextualProperties = {
        Generic: {
            page: cmsPage,
        },
        ButtonStandaloneCms: {
            ctaPosition: 'homepage body',
        },
        FindAGymComponent: {
            gyms,
        },
        AnchorLinks: {
            promoSnackBarOptions,
        },
    };

    return (
        <>
            {organisationSchemaObject && isHomePage && (
                <Head>
                    <script
                        id="organisation-schema-script"
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify(organisationSchemaObject),
                        }}
                    />
                </Head>
            )}
            {titleBox && <CmsContent schema={titleBox} />}
            {content.map((contentItem, index) => (
                <CmsContent
                    /* eslint-disable-next-line no-underscore-dangle */
                    key={uuidv4()}
                    schema={contentItem}
                    contextualProps={contextualProperties}
                />
            ))}
        </>
    );
}
